import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=0f922d8b&"
import script from "../../models/usen-manage/new-edit.ts?vue&type=script&lang=ts&"
export * from "../../models/usen-manage/new-edit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports